import type { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import dynamic from 'next/dynamic';
import React from 'react';

import { base } from 'nextjs/getServerSideProps';
import PageNextJs from 'nextjs/PageNextJs';

const InternalTxs = dynamic(() => import('ui/pages/InternalTxs'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/internal-txs">
      <InternalTxs/>
    </PageNextJs>
  );
};

export default Page;

// export { base as getServerSideProps } from 'nextjs/getServerSideProps';

export const getServerSideProps = async(context) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale, [ 'common' ])),
      ...(await base(context)),
    },
  };
};
